import Component from './Lecture';

export default Component;
